export class AtaskaitosParametraiApi {
  giiKodas: number | null;
  ataskMetai: string = '';
  ataskaitosTipas: string = '';
  registracijosDataNuo: any;
  registracijosDataIki: any;

  constructor(public year: string) {
    this.ataskMetai = year;
    this.giiKodas = null;
  }
}